import { createSlice } from '@reduxjs/toolkit';
import {
  EditAdminPassword,
  EditAdminProfile,
  EditAdminProfilePic,
  getProfile,
} from './profile_service_syn';

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profile: {},
    profileLoader: true,
    editLoader: false,
    profileMessage: '',
    //edit profile
  },
  reducers: {
    clearState: (state) => {
      state.profile = {};
      state.profileLoader = true;
      state.editLoader = false;
      state.profileMessage = '';

      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.profileLoader = true;
      })
      .addCase(getProfile.fulfilled, (state, { payload }) => {
        state.profileLoader = false;
        state.profileMessage = payload?.message;
        state.profile = payload?.data;
      })
      .addCase(getProfile.rejected, (state, { payload }) => {
        state.profileLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(EditAdminProfile.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditAdminProfile.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
        state.profile = payload.data;
      })
      .addCase(EditAdminProfile.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
      })
      .addCase(EditAdminPassword.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditAdminPassword.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;

        const addButton = document.querySelector('[data-bs-dismiss="modal"]');

        if (addButton) {
          addButton.click();
        }
      })
      .addCase(EditAdminPassword.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
      })
      .addCase(EditAdminProfilePic.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditAdminProfilePic.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
        state.profile = payload.data;
      })
      .addCase(EditAdminProfilePic.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload?.message;
      });
  },
});

export const { clearState } = profileSlice.actions;
export const profileSelector = (state) => state.profile;

export default profileSlice.reducer;
